<template>
  <skud-card-list />
</template>

<script>
import SkudCardList from '@/views/skud/components/SkudCardList.vue'

export default {
  name: 'AdminSkudCardList',
  components: { SkudCardList }
}
</script>
